import { FormGroup } from '@angular/forms';

// Base class to centralize Reactive Forms enable/disable behavior for edit modes.
// Generic over the concrete form shape (`TForm`) so subclasses conservam a tipagem dos controles.
export abstract class BaseEditableForm<TForm extends FormGroup = FormGroup> {
    protected form!: TForm;

    protected setForm(form: TForm): void {
        this.form = form;
    }

    enableEditing(): void {
        if (!this.form) return;
        Object.values(this.form.controls).forEach((control) => control.enable());
    }

    disableEditing(): void {
        if (!this.form) return;
        Object.values(this.form.controls).forEach((control) => control.disable());
    }

    // Handlers padrão de edição; componentes sobrescrevem quando precisam.
    saveChanges(saveCallback: (form?: FormGroup) => void = () => {}): void {
        saveCallback(this.form);
        this.disableEditing();
    }

    cancelEditing(cancelCallback: (form?: FormGroup) => void = () => {}): void {
        cancelCallback(this.form);
        this.disableEditing();
    }
}
